/**
 * BroadcastShelf — the Broadcast (marketing automation) surface.
 *
 * The sixth shelf slot. It used to render a ``coming_soon`` chip whose entire
 * onClick was a telemetry event — "Marketing automation lands in Phase 15" —
 * while the surface it described was already routed and live. It now opens it.
 *
 * Round 6 UX vocabulary discipline: top-level label is the
 * verb-as-noun "Broadcast"; no engineering jargon like "Marketing
 * Automation" leaks into the user surface.
 */
import { ShelfCard } from "./ShelfCard";

interface Props {
  projectId?: string | null;
}

export function BroadcastShelf({ projectId }: Props) {
  return (
    <div
      data-testid="broadcast-shelf"
      role="region"
      aria-label="Broadcast"
      className="p-3"
    >
      {/* BROADCAST IS BUILT AND ROUTED. This shelf used to render a dead button
          reading "Marketing automation lands in Phase 15. Click to tell us
          you're waiting on it." — its entire onClick was a telemetry call, it
          navigated nowhere, and the surface it described was already live at
          <Route path="/projects/:projectId/broadcast"> (App.tsx:630, declared in
          the ABSOLUTE form, which is why a nested-path search does not find it).

          Linking here is safe for an org WITHOUT the entitlement: the broadcast
          API is gated on the SVC_BROADCAST add-on (18 orgs hold it) and
          BroadcastRoute already renders an honest "paid add-on, not enabled for
          your organisation" panel rather than a dead end.

          `unavailable` when there is no project, using the same ShelfCard
          primitive every other shelf uses, so this shelf can never send anyone
          to /projects//broadcast. */}
      <ShelfCard
        to={projectId ? `/projects/${projectId}/broadcast` : ""}
        label="Broadcast"
        testId="broadcast-campaigns"
        unavailable={!projectId}
      />
    </div>
  );
}
